import {Badge} from '@/components/ui/badge/Badge'
import {TreatmentRequestSmall} from '@/features/treatment-requests/types'
import {useTranslation} from '@/translations/i18n'
import {
    rejectedReasonToLabel,
    treatmentRequestStatusToColors,
    treatmentRequestStatusToLabel
} from '@/features/treatment-requests/utils'
import {ChangeStatusMenu} from '@/features/treatment-requests/components/change-status-menu/ChangeStatusMenu'
import {Button} from '@/components/ui/button/Button'
import {ChevronDownIcon, SquareIcon} from '@/components/ui/icon/Icon'
import {StyledRejectedReason} from './style'
import {usePermissions} from '@/features/auth/store/store'

export const TreatmentRequestDetailsStatus = ({treatmentRequest}: {treatmentRequest: TreatmentRequestSmall}) => {
    const {t} = useTranslation()
    const {status} = treatmentRequest
    const permissions = usePermissions()

    return !permissions?.requests?.write || status == 'accepted' || status == 'rejected' ? (
        <Badge variant="neutral" size="lg" shape="rectangle">
            <SquareIcon size={8} className="custom" color={treatmentRequestStatusToColors[status]} />
            {t(treatmentRequestStatusToLabel[status], {count: 1})}
            {treatmentRequest.rejectedReason && (
                <StyledRejectedReason>{t(rejectedReasonToLabel[treatmentRequest.rejectedReason])}</StyledRejectedReason>
            )}
        </Badge>
    ) : (
        <ChangeStatusMenu
            patientIds={[treatmentRequest.patientId]}
            selectedTreatmentRequestsCount={1}
            unselectedTreatmentRequestsIds={[]}
            selectedTreatmentRequestsIds={[treatmentRequest.id]}
            selectedTreatmentRequests={[treatmentRequest]}
            trigger={
                <Button size="sm" fullWidth={false} variant="secondary">
                    <SquareIcon size={8} className="custom" color={treatmentRequestStatusToColors[status]} />
                    {t(treatmentRequestStatusToLabel[status], {count: 1})}
                    <ChevronDownIcon />
                </Button>
            }
        />
    )
}
